import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const StarsWithBgIcon = ({
  width = "24",
  height = "24",
  color = "#0860A8",
  secondColor = "#CEDFEE",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="4" fill={secondColor} />
        <path
          d="M10.7539 12.9785L10.8311 13.1689L11.0215 13.2461L13.9062 14.3994L11.0215 15.5547L10.8311 15.6309L10.7539 15.8213L9.59961 18.7061L8.44531 15.8213L8.36914 15.6309L8.17871 15.5547L5.29297 14.3994L8.17871 13.2461L8.36914 13.1689L9.59961 10.0928L10.7539 12.9785ZM16.3516 7.36719L16.4287 7.57129L16.6328 7.64844L18.6328 8.39941L16.6328 9.15039L16.4287 9.22754L16.3516 9.43164L15.5996 11.4326L14.8496 9.43164L14.7725 9.22754L14.5684 9.15039L12.5664 8.39941L14.5684 7.64844L14.7725 7.57129L14.8496 7.36719L15.5996 5.36621L16.3516 7.36719Z"
          stroke={color}
          strokeWidth="0.960001"
        />
      </svg>
    </IconWrapper>
  );
};
